import React from "react"
import {
  RadioGroup,
  FormControl,
  FormControlLabel,
  Radio,
  FormLabel,
} from "@material-ui/core"

import { FormField } from "../../styles/Form"
import { PubliseringModel, PubliseringAction } from "../../store/publisering"
import { UIModel } from "../../store/ui"
import SharedFylkeSelectSingle from "@nvdb-rapport/shared/src/components/AreaSelect/FylkeSelectSingleNew"
import "twin.macro"

interface AreaSelectGenererVeglisterProps {
  publiseringState: PubliseringModel
  publiseringDispatch: React.Dispatch<PubliseringAction>
  uiState: UIModel
}

export default function AreaSelectGenererVeglister({
  publiseringState,
  publiseringDispatch,
  uiState,
}: AreaSelectGenererVeglisterProps) {
  const vegsystem = publiseringState.vegsystem

  return (
    <FormField tw="flex flex-col">
      <FormControl required style={{ width: "100%" }}>
        <FormLabel style={{ textAlign: "left", width: "100%" }}>
          Vegtype
        </FormLabel>
        <RadioGroup
          aria-label="vegfilter-label"
          name="vegsystem"
          value={vegsystem}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            publiseringDispatch({
              type: "UpdateVegsystem",
              payload: e.target.value,
            })
          }}
        >
          <FormControlLabel
            value="EV,RV"
            control={<Radio color="primary" size="small" />}
            label="Riksveger"
          />
          <FormControlLabel
            value="FV,KV"
            control={<Radio color="primary" size="small" />}
            label="Fylkes- og kommunale veger"
          />
        </RadioGroup>
      </FormControl>
      {vegsystem === "FV,KV" && (
        <SharedFylkeSelectSingle
          language={uiState.language}
          areaMappings={uiState.areaMappings}
          selectedFylke={publiseringState.selectedFylke}
          omraader={uiState.omraader}
          selectFylke={fylkeNr =>
            publiseringDispatch({
              type: "SelectFylke",
              payload: fylkeNr,
            })
          }
        />
      )}
    </FormField>
  )
}
